export default __webpack_public_path__ + "assets/audio.d2cbc3d0.svg";